import { useParams } from "react-router-dom";
import DescriptionTable from "./DescriptionTable";
import { Col, Container, Row } from "reactstrap";
import DataLinesTable from "./DataLinesTable";
import ATMTable from "./ATMTable";
import PhoneLinesTable from "./PhoneLinesTable";
import SubordinateUnitsTable from "./SubordinateUnitsTable";


const DetailsPage = ()  => {
  const { unitType = "", unitID = "-1" } = useParams<DetailsPageParams>();
  let title = "";

  switch (unitType) {
    case "Units":
      title = "Μονάδα"
      break;
    case "Establishments":
      title = "Κατάστημα"
      break;
    case "Departments":
      title = "Διεύθυνση"
      break;
    case "DCompanies":
      title = "Θυγατρική"
      break;
    case "ATM":
      title = "ATM"
      break;  
    default:
      break;
  }
  
  return (
    <div className="page-content">
      <Container>
        <Row>
          <Col xs="12">
            <div className="text-center">
              <span style={{ fontSize: "2rem", fontWeight: "bold" }}>Λεπτομέρειες Μονάδας</span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <div className="text-center">
              <span className="h1">{title}</span>
            </div>
            <DescriptionTable 
              unitID={+unitID}
              unitType={unitType}
            />
          </Col>
        </Row>
      </Container>

      <Container fluid>
        <Row>
          <Col xs="12">
            <hr />
          </Col>
        </Row>

        <Row>
          <Col xs="12">
            <div className="text-center">
              <span className="h1">Γραμμές Data</span>
            </div>
            <DataLinesTable 
              unitID={+unitID}
            />
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          <Col xs="12">
            <hr />
          </Col>
        </Row>
      </Container>

      <Container fluid>
        <Row>
          <Col xs="12">
            <div className="text-center">
              <span className="h1">ATM</span>
            </div>
            <ATMTable 
              unitID={+unitID}
            />
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          <Col xs="12">
            <hr />
          </Col>
        </Row>
      </Container>

      <Container fluid>
        <Row>
          <Col xs="12">
            <div className="text-center">
              <span className="h1">Τηλεφωνικές Γραμμές</span>
            </div>
            
            <PhoneLinesTable 
              unitID={+unitID}
            />
          </Col>
        </Row>
      </Container> 

      <Container fluid>
        <Row>
          <Col xs="12">
            <hr />
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <div className="text-center">
              <span className="h1">Υπαγόμενες Μονάδες</span>
            </div>
            <SubordinateUnitsTable 
              unitID={+unitID}
            />
          </Col>
        </Row>
      </Container> 
    </div>  
  )
}

interface DetailsPageParams extends Record<string, string> {
  unitId: string;
  unitType: "Units" | "Establishments" | "Departments" | "DCompanies" | "ATM";
}

export default DetailsPage;